import { Box, Stack, Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { AppContext } from "../../utils";

function ExternalPoints() {
  const { tweetHashTagsData } = useContext(AppContext);

  return (
    <Stack alignItems={"center"} my={4}>
      <Box
        sx={{
          border: "5px solid #ffffff",
          borderRadius: "15px",
          backgroundColor: "#8102FF",
          width: { xs: "90%", sm: "80%" },
          pt: 4,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontFamily: "Saira Semi Condensed",
            fontWeight: 900,
            fontSize: { xs: "24px", sm: "40px" },
            lineHeight: "50px",
            textAlign: "center",
            letterSpacing: "1px",
            color: "#ffffff",
            textTransform: "uppercase",
            mx: { xs: 0.5, sm: 2, md: 0 },
          }}
        >
          $BGAI TOTAL points <br />
          Earned{" "}
          <span style={{ fontWeight: "500" }}>
            {+tweetHashTagsData?.postPoints +
              +tweetHashTagsData?.viewsPoints +
              +tweetHashTagsData?.commentsPoints +
              +tweetHashTagsData?.likesPoints +
              +tweetHashTagsData?.retweetPoints +
              +tweetHashTagsData?.quotePoints}
          </span>
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontFamily: "Montserrat",
            fontWeight: 400,
            fontSize: { xs: "14px", sm: "16px" },
            lineHeight: "26px",
            textAlign: "center",
            color: "#ffffff",
            mt: { xs: 1, sm: 3 },
            mb: 2,
            mx: { xs: 4, sm: 2, md: 0 },
          }}
        >
          Rate for exchanging points into token 10 points = 1 token
        </Typography>
      </Box>
    </Stack>
  );
}

export default ExternalPoints;
